<template>
  <section v-bind="sectionProps">
    <v-container v-bind="containerProps">
      <iframe v-bind="mapProps" v-if="!builder"></iframe>

      <v-img
        v-else
        :height="this.section.layout['map-height'] || 450"
        src="@/assets/images/map_placeholder.jpg"
      ></v-img>
    </v-container>

    <slot name="toolbar"></slot>
  </section>
</template>

<script>
export default {
  name: 'MapFullwidthSection',
  props: {
    section: {
      type: Object,
      required: true
    },
    templateSettings: {
      type: Object,
      required: true
    },
    builder: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    mapApiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY
  }),
  computed: {
    mapEmbedUrl() {
      let lat = this.section.content['map-latitude'] || '59.921167'
      let long = this.section.content['map-longitude'] || '10.757151'
      let zoom = this.section.content['map-zoom'] || '15'

      return `https://www.google.com/maps/embed/v1/place?key=${this.mapApiKey}&q=${lat},${long}&zoom=${zoom}`
    },
    mapProps() {
      return {
        width: '100%',
        height: this.section.layout['map-height'] || 450,
        style: {
          border: 0,
          marginBottom: '-5px'
        },
        loading: 'lazy',
        allowfullscreen: true,
        src: this.mapEmbedUrl
      }
    },
    sectionProps() {
      return {
        class: ['py-0']
      }
    },
    containerProps() {
      return {
        class: ['px-0'],
        fluid: true
      }
    }
    // contentRowProps() {
    //   return {
    //     'no-gutters': true,
    //     class: [
    //       `justify-${this.section.layout['content-horizontal-alignment']}`,
    //       `text-${this.section.layout['content-justify']}`
    //     ]
    //   }
    // },
    // contentColumnProps() {
    //   let additionalProps = {}

    //   if (!this.parseBoolean(this.section.layout['content-container-fluid'])) {
    //     additionalProps = {
    //       ...this.calculateColumnContainerSize(
    //         this.section.layout['content-container-size']
    //       )
    //     }
    //   }

    //   return {
    //     ...additionalProps,
    //     style: {
    //       position: 'relative',
    //       padding: this.parseBoolean(this.section.layout['content-box'])
    //         ? this.section.layout['content-box-padding']
    //         : 0
    //     }
    //   }
    // },
    // contentInnerRowProps() {
    //   return {
    //     class: [`align-${this.section.layout['content-vertical-alignment']}`]
    //   }
    // },
    // mapColumnProps() {
    //   return {
    //     ...this.calculateImageColumns(this.section.layout['map-size']),
    //     'order-md': this.section.layout['map-position'] == 'left' ? 0 : 1,
    //     class: ['py-0']
    //   }
    // },
    // textColumnProps() {
    //   return {
    //     ...this.calculateTextColumns(this.section.layout['map-size'])
    //   }
    // },
    // titleProps() {
    //   return {
    //     is: this.section.design['title-tag'],
    //     style: {
    //       color: this.section.design['title-color'],
    //       fontWeight: this.section.design['title-font-weight']
    //     }
    //   }
    // },
    // introtextProps() {
    //   return {
    //     style: {
    //       color: this.section.design['introtext-color']
    //     }
    //   }
    // },
    // contentBoxProps() {
    //   let additionalClass = []

    //   if (this.parseBoolean(this.section.layout['content-box-rounded'])) {
    //     additionalClass.push('rounded')
    //   }

    //   return {
    //     class: [
    //       `elevation-${this.section.layout['content-box-elevation']}`,
    //       ...additionalClass
    //     ],
    //     style: {
    //       position: 'absolute',
    //       top: 0,
    //       bottom: 0,
    //       left: 0,
    //       right: 0,
    //       zIndex: -1,
    //       backgroundColor: this.section.layout['content-box-color'],
    //       opacity: this.section.layout['content-box-opacity']
    //     }
    //   }
    // }
  }
}
</script>
